var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVFinancialHelp = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsxs("g", __assign({ clipPath: "url(.clip0_12_1737)", fill: "currentColor" }, { children: [_jsx("path", { d: "M11.082 9.062a.65.65 0 0 1 .907-.153l1.344.957a1 1 0 0 0 1.16-1.63l-1.345-.956a2.7 2.7 0 0 0-.163-.108A1.01 1.01 0 0 0 13 7V5a1 1 0 1 0-2 0v1.86a2.65 2.65 0 0 0-.924 4.738l2.689 1.913a.65.65 0 1 1-.754 1.06l-1.344-.957a1 1 0 0 0-1.16 1.63l1.345.956c.049.035.098.067.148.098V18.5a1 1 0 1 0 2 0v-1.881a2.65 2.65 0 0 0 .924-4.738L11.235 9.97a.65.65 0 0 1-.153-.907Z" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z" })] }))] })));
};
export default SvgVFinancialHelp;
